export default function execFormScripts(script, { formApi, restApi, messageApi, i18nApi }) {
  (function bindThis() {
    // eslint-disable-next-line no-eval
    eval(script);
  }.call({ formApi, restApi, messageApi, i18nApi }));
}
